module.exports = __webpack_public_path__ + "img/about-feedback.19df8f1.png";